export const lightTheme = {
    body:"#FCF6F4",
    text:"#000000",
    bodyRgba : "252, 246, 244",
    textRgba: "0,0,0",
    isLight: true,
}
export const darkTheme = {
    body:"#000000",
    text:"#FCF6F4",
    textRgba: "252, 246, 244",
    isLight: false,
}